<script>
import {
  ArrowUpIcon,
  FacebookIcon,
  InstagramIcon,
  TwitterIcon,
  LinkedinIcon,
  BellIcon,
  BellOffIcon,
} from "vue-feather-icons";
// import { Slide } from "vue-carousel";
// import { Carousel } from "vue-carousel";
// import { VueTyper } from "vue-typer";
import Multiselect from "vue-multiselect";
import IndexService from "@/MainServices/IndexService.js";
import Navbar from "@/view/front/components/navbar";
import Switcher from "@/view/front/components/switcher";
import Footer from "@/view/front/components/footer";
import SkeletonLoader from "@/view/front/components/SkeletonLoader.vue";
import SkeletonLoader_1 from "@/view/front/components/SkeletonLoader_1.vue";
import SkeletonLoader_2 from "@/view/front/components/SkeletonLoader_2.vue";
import axios from "axios";
import { API_URL, MEDIA_URL } from "@/core/api";
import formValidation from "@/assets/plugins/formvalidation/dist/es6/core/Core";

// FormValidation plugins
import Trigger from "@/assets/plugins/formvalidation/dist/es6/plugins/Trigger";
import Bootstrap from "@/assets/plugins/formvalidation/dist/es6/plugins/Bootstrap";
import SubmitButton from "@/assets/plugins/formvalidation/dist/es6/plugins/SubmitButton";

import KTUtil from "@/assets/js/components/util";
import { mapGetters, mapState } from "vuex";
import { LOGIN, LOGOUT, REGISTER } from "@/core/services/store/auth.module";
import Swal from "sweetalert2";

/**
 * page-index-home component
 */
export default {
  metaInfo: function() {
    return {
      title:
        "job4u.pk - Find your dream job and recruit best talent in Pakistan",
      meta: [
        {
          name: "description",
          content:
            "we are jobs portal with thousands of jobs & career opportunities for candidates in Pakistan and for recruiters to hire best resources for their companies.",
        },
      ],
    };
  },

  data() {
    return {
      loading: true,
      mediaUrl: MEDIA_URL,
      apiUrl: API_URL,
      token:
        localStorage.getItem("token") !== null
          ? `Bearer ${localStorage.getItem("token")}`
          : null,
      data: [],
      search_text: "",
      selected_cities: [],
      city: "",
      cities: [],
      originalData: [],
      show_load_more: true,
      page_num: 1,
      sectorsData: [],
      jobIndustries: [],
      CompaniesList: [],
      featureData: [],
      spotlightData: [],
      urgentData: [],
      featureCompaniesData: [],
      recruiterSignUp: false,
      agencySignUp: false,
      descriptionSearch: false,
      form: {
        email: "",
        password: "",
      },
    };
  },
  components: {
    Navbar,
    Switcher,
    Footer,
    SkeletonLoader,
    SkeletonLoader_1,
    SkeletonLoader_2,
    // Carousel,
    // Slide,
    FacebookIcon,
    InstagramIcon,
    TwitterIcon,
    LinkedinIcon,
    ArrowUpIcon,
    // "vue-typer": VueTyper,
    Multiselect,
    // Skeleton,
    BellIcon,
    BellOffIcon,
    ...mapState({
      errors: (state) => state.auth.errors,
    }),
    ...mapGetters(["currentUser"]),
  },
  mounted() {
    var link = !!document.querySelector("link[rel='canonical']")
      ? document.querySelector("link[rel='canonical']")
      : document.createElement("link");
    link.setAttribute("rel", "canonical");
    link.setAttribute(
      "href",
      location.protocol + "//" + location.host + location.pathname
    );
    document.head.appendChild(link);
    IndexService.getCities().then((res) => {
      res.data.map((el) => {
        this.cities.push({
          id: el.id,
          value: el.city_name,
        });
      });
    });
    this.getSectors();
    this.getFeatureJobs();
    this.getSpotlightJobs();
    this.getFeatureCompanies();
    this.getUrgentJobs();
    this.getJobIndustries();
    this.getCompaniesList();
    if (window.location.href.indexOf("register") !== -1) {
      this.showForm("signup");
    }
    // if (window.location.href.indexOf("forgot") !== -1) {
    //   this.showForm("forgot");
    // }
    const signin_form = KTUtil.getById("kt_login_signin_form");
    const signup_form = KTUtil.getById("kt_login_signup_form");
    // const forgot_form = KTUtil.getById("kt_login_forgot_form");

    this.fv = formValidation(signin_form, {
      fields: {
        email: {
          validators: {
            notEmpty: {
              message: "Username is required",
            },
          },
        },
        password: {
          validators: {
            notEmpty: {
              message: "Password is required",
            },
          },
        },
      },
      plugins: {
        trigger: new Trigger(),
        submitButton: new SubmitButton(),
        bootstrap: new Bootstrap(),
      },
    });

    this.fv1 = formValidation(signup_form, {
      fields: {
        compnay_name_ref: {
          validators: {
            notEmpty: {
              message: "Compnay name is required",
            },
          },
        },
        email: {
          validators: {
            notEmpty: {
              message: "Email is required",
            },
            emailAddress: {
              message: "The value is not a valid email address",
            },
          },
        },
        password: {
          validators: {
            notEmpty: {
              message: "Password is required",
            },
          },
        },
        cpassword: {
          validators: {
            notEmpty: {
              message: "Confirm password is required",
            },
            identical: {
              compare: function() {
                return signup_form.querySelector('[name="password"]').value;
              },
              message: "Passwords do not match",
            },
          },
        },
        agree: {
          validators: {
            notEmpty: {
              message: "Please accept terms and conditions",
            },
          },
        },
      },
      plugins: {
        trigger: new Trigger(),
        submitButton: new SubmitButton(),
        bootstrap: new Bootstrap(),
      },
    });
  },
  methods: {
    agencySignUp_fun() {
      this.agencySignUp = true;
      this.recruiterSignUp = false;
    },
    recruiterSignUp_fun() {
      this.agencySignUp = false;
      this.recruiterSignUp = true;
    },
    onSubmitLogin() {
      this.fv.validate();

      this.fv.on("core.form.valid", () => {
        var email = this.form.email;
        var password = this.form.password;

        // clear existing errors
        this.$store.dispatch(LOGOUT);

        // set spinner to submit button
        const submitButton = this.$refs["kt_login_signin_submit"];
        submitButton.classList.add("spinner", "spinner-light", "spinner-right");

        // dummy delay
        setTimeout(() => {
          // send login request
          this.$store
            .dispatch(LOGIN, { email, password })
            // go to which page after successfully login

            .then((res) => {
              localStorage.setItem("user", JSON.stringify(res));
              localStorage.setItem("token", res.token);
              // this.$router.push({ name: "dashboard" });
              // window.location.reload();
              window.location.href = "/dashboard";
            });

          submitButton.classList.remove(
            "spinner",
            "spinner-light",
            "spinner-right"
          );
        }, 1000);
      });

      this.fv.on("core.form.invalid", () => {
        Swal.fire({
          title: "",
          text: "Please, provide correct data!",
          icon: "error",
          confirmButtonClass: "btn btn-secondary",
          heightAuto: false,
        });
      });
    },
    onImageLoadFailure(event) {
      event.target.src = "../images/profile_ch.jpg";
    },
    onSubmitRegister() {
      const valdidco_name = this.agencySignUp == true ? true : false;
      if ((this.recruiterSignUp == false, this.agencySignUp == false)) {
        Swal.fire({
          title: "",
          text: "Please Select Job Sekeer OR Direct employer.",
          icon: "error",
          confirmButtonClass: "btn btn-secondary",
          heightAuto: false,
        });
        return;
      }
      if (valdidco_name == true) {
        if (
          (this.$refs.compnay_name_ref.value == null,
          this.$refs.compnay_name_ref.value == "")
        ) {
          Swal.fire({
            title: "",
            text: "Compnay name is required.",
            icon: "error",
            confirmButtonClass: "btn btn-secondary",
            heightAuto: false,
          });
          return;
        }
      }
      this.fv1.validate();
      this.fv1.validate().then((res) => {
        if (res == "Valid") {
          const firstName = this.$refs.firstName.value;
          const email = this.$refs.remail.value;
          const password = this.$refs.rpassword.value;
          const compnay_name =
            this.agencySignUp == true
              ? this.$refs.compnay_name_ref.value
              : null;

          // clear existing errors
          this.$store.dispatch(LOGOUT);

          // set spinner to submit button
          const submitButton = this.$refs["kt_login_signup_submit"];
          submitButton.classList.add(
            "spinner",
            "spinner-light",
            "spinner-right"
          );
          // dummy delay
          setTimeout(() => {
            // send register request
            this.$store.dispatch(REGISTER, {
              email: email,
              password: password,
              name: firstName,
              compnay_name: compnay_name,
              role_id:
                this.recruiterSignUp == true
                  ? "1"
                  : this.agencySignUp == true
                  ? "2"
                  : "2",
            });
            submitButton.classList.remove(
              "spinner",
              "spinner-light",
              "spinner-right"
            );
          }, 2000);
        } else {
          Swal.fire({
            title: "",
            text: "Please, provide correct data!",
            icon: "error",
            confirmButtonClass: "btn btn-secondary",
            heightAuto: false,
          });
        }
      });

      this.fv1.on("core.form.invalid", () => {
        Swal.fire({
          title: "",
          text: "Please, provide correct data!",
          icon: "error",
          confirmButtonClass: "btn btn-secondary",
          heightAuto: false,
        });
      });
    },
    _descriptionSearch(event) {
      this.descriptionSearch = event.target.checked;
    },
    search() {
      this.$router.push({
        name: "search",
        params: {
          search_text: this.search_text,
          selected_cities: this.selected_cities,
          description_search: this.descriptionSearch,
        },
      });
    },
   async getSectors() {
      await axios.get(`${this.apiUrl}/get-job-sectors`).then((response) => {
        this.sectorsData = response.data;
        this.loading = false;
      });
    },
    async getJobIndustries() {
      await axios.get(`${this.apiUrl}/get-job-industries`).then((response) => {
        this.jobIndustries = response.data;
        // this.loading = false;
      });
    },
   async getFeatureJobs() {
     await axios.get(`${this.apiUrl}/get-feature-jobs`).then((response) => {
        this.featureData = response.data;
      });
    },
   async  getSpotlightJobs() {
      await axios.get(`${this.apiUrl}/get-spotlight-jobs`).then((response) => {
        this.spotlightData = response.data;
      });
    },
   async getUrgentJobs() {
     await axios.get(`${this.apiUrl}/get-urgent-jobs`).then((response) => {
        this.urgentData = response.data;
      });
    },
   async getCompaniesList() {
      this.loading = true;
     await axios.get(`${this.apiUrl}/get-companies-list`).then((response) => {
        this.CompaniesList = response.data;
      });
    },
  async getFeatureCompanies() {
      if (this.token !== null) {
        axios.defaults.headers.common["Authorization"] = this.token;
        await axios
          .get(`${this.apiUrl}/get-feature-companies-auth`)
          .then((response) => {
            this.featureCompaniesData = response.data;
          });
      } else {
       await axios.get(`${this.apiUrl}/get-feature-companies`).then((response) => {
          this.featureCompaniesData = response.data;
        });
      }
    },
  },
};
</script>

<template>
  <div>
    <Navbar />

    <!-- Hero Start -->
    <!-- <div class="container"> -->
    <section class="bg-white w-100 margin_top_page">
      <!-- hero section -->
      <div class="home_new">
        <div class="row container" style="margin: 0 auto">
          <div class="col-lg-7 pl-0">
            <div class="pb-12 pt-22 for_mobile_p_bAndch">
              <h1 class="hero_heading hero_heading_mb">
                For targeted hassle-free<br class="by-nine-ch" />
                fast recruitment & job hunt
              </h1>
              <p class="p_home_new">
                Whether you are looking for a better candidate or a better
                career,
                <br class="by-nine-ch" />we’ll get you there!
              </p>
            </div>
            <div class="row m-0">
              <div
                class="col-md-5 form-group m-0 pl-0 custom_input position__ch"
              >
                <input
                  type="text"
                  v-model="search_text"
                  @keyup.enter="search()"
                  class="form-control fieldch_new selectch b-r-8-ch"
                  placeholder="What job are you looking for"
                />
                <img
                  src="/images/s_1.svg"
                  width="15"
                  height="15"
                  alt="..."
                  class="icon_search__"
                />
              </div>

              <div class="col-md-5 form-group m-0 p-0 position__ch">
                <multiselect
                  class="fieldch_new selectch home_city_selct b-r-8-ch"
                  id="multiselectCities"
                  v-model="selected_cities"
                  :height="300"
                  :options="cities"
                  :multiple="true"
                  :close-on-select="false"
                  :clear-on-select="false"
                  :preserve-search="true"
                  placeholder="My ideal job location(s) "
                  label="value"
                  track-by="value"
                  :preselect-first="false"
                >
                </multiselect>
                <img
                  src="images/s_2.svg"
                  width="15"
                  height="15"
                  alt="..."
                  class="icon_search__"
                />
              </div>
              <div class="col-md-2 form-group home_btn_col_ch">
                <button
                  @click="search()"
                  type="button"
                  class="
                    btn btn-default btn_red_redus
                    b-r-8-ch
                    button_by_ch_new_home
                  "
                >
                  Search
                </button>
              </div>

              <div class="col-md-6 form-group mb-0 mt-2 pl-0">
                <div class="checkboxch chabox_ch_home">
                  <label class="text-white pl-8 mt-3"
                    ><input
                      type="checkbox"
                      value="Yes"
                      style="margin-left: -25px"
                      class="form-check-input"
                      v-on:click="_descriptionSearch($event)"
                    />
                    Search job title only</label
                  >
                </div>
              </div>
              <div
                class="col-sm-12 form-group m-0 pl-0 pb-20 pt-0 for_mobile_p_bAndch1"
              >
                <p class="mt-2 mb-0 text-white">
                  <b class="text-white ch_link_c2 d-block mb-5"
                    >Quick searches:</b
                  ><a class="ch_link_c text-white" href="/jobs-in-pakistan"
                    >Latest Jobs</a
                  >
                  <a class="ch_link_c text-white" href="/jobs-in-pakistan"
                    >Recent Searches</a
                  >
                  <a class="ch_link_c text-white" href="#">Internships</a>
                  <a class="ch_link_c text-white" href="/jobs-in-pakistan?Urgent-Jobs"
                    >Urgent Jobs</a
                  >
                </p>
              </div>
            </div>
          </div>
          <div class="col-lg-5">
            <img
              class="hero_img"
              src="images/new_home/Hero_Overlay_image.svg"
              alt=""
            />
          </div>
        </div>
      </div>
      <!-- new tabs -->
      <div class="container px-3 pt-20 pb-20 home_fix_ch">
        <div class="row_by-ch p-0 m-0">
          <div class="col-lg-8_by-ch col-12 row m-0 bg-light-new-home">
            <div
              class="col-md-12 d-flex justify-content-between home_fix_heading"
            >
              <h3 class="leatext_job_heading_by_new_home">Latest jobs:</h3>
              <ul
                class="nav nav-pills d-flex"
                id="pills-tab"
                role="tablist"
                style="background: transparent"
              >
                <li class="nav-item" role="presentation">
                  <button
                    class="nav-link active newest_btn_new_home"
                    id="pills-profile-tab"
                    data-bs-toggle="pill"
                    data-bs-target="#pills-profile"
                    type="button"
                    role="tab"
                    aria-controls="pills-profile"
                    aria-selected="false"
                  >
                    By sector
                  </button>
                </li>
                <li class="nav-item text-center" role="presentation">
                  <button
                    class="nav-link newest_btn_new_home"
                    id="pills-home-tab"
                    data-bs-toggle="pill"
                    data-bs-target="#pills-home"
                    type="button"
                    role="tab"
                    aria-controls="pills-home"
                    aria-selected="true"
                  >
                    By industry
                  </button>
                </li>
              </ul>
            </div>
            <div v-if="loading == true">
              <div class="col-md-12 new_home_">
                <hr class="new_home_hr" />
                <div class="tab-content" id="pills-tabContent">
                  <SkeletonLoader />

                  <div
                    class="tab-pane fade"
                    id="pills-home"
                    role="tabpanel"
                    aria-labelledby="pills-home-tab"
                  >
                    <div class="row">
                      <div
                        v-for="sk in 9"
                        :key="'sk-industry-' + sk"
                        class="col-6 col-lg-4 line"
                      >
                        <div class="newst_secter_list">
                          <span class="d-block" style="min-height: 1.25rem">&nbsp;</span>
                        </div>
                      </div>
                    </div>
                    <hr class="new_home_hr" />
                    <div>
                      <a class="by_view_all" href="/job-industries"
                        >See all industries &nbsp;&nbsp;<img
                          src="images/new_home/Arrow.webp"
                          alt="view-all-industries-icon"
                      /></a>
                    </div>
                  </div>
                  <div
                    class="tab-pane fade show active"
                    id="pills-profile"
                    role="tabpanel"
                    aria-labelledby="pills-profile-tab"
                  >
                    <div class="row">
                      <div
                        class="col-6 col-lg-4"
                        v-for="(item, index) in sectorsData"
                        :key="index"
                        :style="index < 21 ? '' : 'display: none '"
                      >
                        <div class="newst_secter_list">
                          <router-link
                            v-if="index < 20"
                            :to="
                              '/jobs-careers-pakistan/jobs-sector/' +
                                item.job_function_name
                                  .toLowerCase()
                                  .replace(/ /g, '-')
                            "
                            >{{ item.job_function_name }}
                          </router-link>
                          <router-link v-if="index === 20" :to="'/job-sectors'"
                            >View All
                            <i class="ml-1 fa fa-angle-right"></i>
                          </router-link>
                        </div>
                      </div>
                    </div>
                    <hr class="new_home_hr" />
                    <div>
                      <a class="by_view_all" href="/job-sectors"
                        >See all sectors &nbsp;&nbsp;<img
                          src="images/new_home/Arrow.webp"
                          alt="view-all-sectors-icon"
                      /></a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div v-else>
              <div class="col-md-12 new_home_">
                <hr class="new_home_hr" />
                <div class="tab-content" id="pills-tabContent">
                  <div
                    class="tab-pane fade"
                    id="pills-home"
                    role="tabpanel"
                    aria-labelledby="pills-home-tab"
                  >
                    <div class="row">
                      <div
                        class="col-6 col-lg-4 line"
                        v-for="(item, index) in jobIndustries"
                        :key="index"
                        :style="index < 21 ? '' : 'display: none '"
                      >
                        <div class="newst_secter_list">
                          <router-link
                            v-if="index < 20"
                            :to="
                              '/jobs-careers-pakistan/jobs-industry/' +
                                item.industry_name
                                  .toLowerCase()
                                  .replace(/ /g, '-')
                            "
                            >{{ item.industry_name }}
                          </router-link>
                          <router-link
                            v-if="index === 20"
                            :to="'/job-industries'"
                            >View All
                            <i class="ml-1 fa fa-angle-right"></i>
                          </router-link>
                        </div>
                      </div>
                    </div>
                    <hr class="new_home_hr" />
                    <div>
                      <a class="by_view_all" href="/job-industries"
                        >See all industries &nbsp;&nbsp;<img
                          src="images/new_home/Arrow.webp"
                          alt="view-all-industries-icon"
                      /></a>
                    </div>
                  </div>
                  <div
                    class="tab-pane fade show active"
                    id="pills-profile"
                    role="tabpanel"
                    aria-labelledby="pills-profile-tab"
                  >
                    <div class="row">
                      <div
                        class="col-6 col-lg-4"
                        v-for="(item, index) in sectorsData"
                        :key="index"
                        :style="index < 21 ? '' : 'display: none '"
                      >
                        <div class="newst_secter_list">
                          <router-link
                            v-if="index < 20"
                            :to="
                              '/jobs-careers-pakistan/jobs-sector/' +
                                item.job_function_name
                                  .toLowerCase()
                                  .replace(/ /g, '-')
                            "
                            >{{ item.job_function_name }}
                          </router-link>
                          <router-link v-if="index === 20" :to="'/job-sectors'"
                            >View All
                            <i class="ml-1 fa fa-angle-right"></i>
                          </router-link>
                        </div>
                      </div>
                    </div>
                    <hr class="new_home_hr" />
                    <div>
                      <a class="by_view_all" href="/job-sectors"
                        >See all sectors &nbsp;&nbsp;<img
                          src="images/new_home/Arrow.webp"
                          alt="view-all-sectors-icon"
                      /></a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            class="
              col-lg-4-by_ch
              col-12
              row
              m-0
              bg-light-new-home_4
              new_home_
              pb-5
            "
          >
            <h3 class="h3_by_new_home_blue">
              Assisted <br class="by-nine-ch" />Recruitment

            </h3>
            <p class="m-0 p_by_new_home_blue">
              Do you need a hand with recruiting<br class="by-nine-ch" />
              top talent from Pakistan ? Let us<br class="by-nine-ch" />
              assist you with that !
            </p>
            <img
              class="img_ne_h_img"
              src="images/new_home/Recruitment-assistance.webp"
              alt="Recruitment Assistance image"
            />
            <hr class="new_home_hr" />
            <div>
              <a
                class="by_view_all"
                href="#"
                data-toggle="tooltip"
                data-html="true"
                title="Coming soon"
                >Contact us &nbsp;&nbsp;<img
                  src="images/new_home/Arrow.webp"
                  alt="view-all-industries-icon"
              /></a>
            </div>
          </div>
        </div>
      </div>
      <!-- fucher premmiem jobs -->
      <div class="new_home_ mb-20">
        <div
          class="container row_by-ch2 pr-3 home_fixes_new_ch"
          style="margin: 0 auto"
        >
          <div class="col-lg-8_by-ch pl-0">
            <div class="bg-white">
              <div class="col-lg-12 p-0">
                <div class="px-4">
                  <div class="row my-0">
                    <div class="col-lg-9 col-7 pb-0 pl-0 pr-0 mb-0">
                      <h3 class="leatext_job_heading_by_new_home pb-0">
                        Featured Jobs:
                      </h3>
                    </div>
                    <div
                      class="col-lg-3 col-5 p-0 chchchch"
                      style="text-align: end"
                    >
                      <div>
                        <a class="by_view_all" href="/jobs-in-pakistan"
                          >View All &nbsp;&nbsp;<img
                            src="images/new_home/Arrow.webp"
                            alt="view-all-industries-icon"
                        /></a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div v-if="loading == true">
                <div class="col-sm-12 pr-0">
                  <SkeletonLoader_1 />
                  <div class="row">
                    <div
                      v-for="sk in 6"
                      :key="'sk-fjobs-' + sk"
                      class="col-xs-12 col-sm-6 col-md-4 col-lg-4 p-0"
                    >
                      <div class="well new_home_col_jobs" style="min-height: 140px">
                        &nbsp;
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div v-else>
                <div class="col-sm-12 pr-0">
                  <div class="row">
                    <div
                      class="col-xs-12 col-sm-6 col-md-4 col-lg-4 p-0"
                      v-for="(item, index) in featureData"
                      :key="index"
                    >
                      <!-- {{item}} urgent-->
                      <div v-if="index < 12" class="well new_home_col_jobs">
                        <div class="media" style="overflow: visible;">
                          <div
                            class="media-left p-0 pr-2"
                            style="position: relative;"
                          >
                            <router-link
                              v-if="index < 12"
                              :to="
                                '/jobs-careers/pakistan/' +
                                  item.location_city
                                    .map((v) => v.toLowerCase())
                                    .join('-') +
                                  '/' +
                                  item.job_title
                                    .toLowerCase()
                                    .replace(/ /g, '-')
                                    .replace(/[^\w-]+/g, '') +
                                  '/' +
                                  item.id
                              "
                            >
                              <img
                                class="verfiyed_compony___"
                                src="images/new_home/Verified.svg"
                                alt="Verified Compony"
                              />
                              <img
                                class="media-object img-circle new_style_logo"
                                @error="onImageLoadFailure($event)"
                                :src="
                                  mediaUrl + item.recruiter.profile_pic || ''
                                "
                                width="40"
                                height="40"
                                alt="logo"
                                style="object-fit: cover"
                              />
                            </router-link>
                            <!-- <div class="col-5 p-0 m-0 left_and_bottom_flex"> -->
                            <!-- <span class="d-block mx-0 mt-2 span_verfiyd_job Full-time_">Featured</span> -->
                            <!-- <span class="d-block mx-0 mt-2 span_verfiyd_job">Verified</span> -->
                            <!-- <span class="span_verfiyd_job Contract_ m-0" v-if="item.urgent == 1">Urgent</span> -->
                            <!-- </div> -->
                          </div>
                          <div class="media-body media-right p-0">
                            <h5 class="media-heading text-primary">
                              <router-link
                                :to="
                                  '/jobs-careers/pakistan/' +
                                    item.location_city
                                      .map((v) => v.toLowerCase())
                                      .join('-') +
                                    '/' +
                                    item.job_title
                                      .toLowerCase()
                                      .replace(/ /g, '-')
                                      .replace(/[^\w-]+/g, '') +
                                    '/' +
                                    item.id
                                "
                                class="job_title_new_home"
                              >
                                {{ item.job_title }}
                              </router-link>
                            </h5>
                            <div class="row m-0 p-0">
                              <div class="col-12 pl-0 m-0">
                                <p
                                  style="
                                  display: block !important;
                                  font-size: 14px;
                                "
                                >
                                  {{ item.recruiter.company_name }}
                                </p>
                                <p style="color: #009cc6; font-size: 12px">
                                  {{ item.location_city.join(", ") }}
                                </p>
                              </div>
                              <!-- <div class="col-5 p-0 m-0 left_and_bottom_flex"> -->
                              <!-- <span class="d-block mx-0 mt-2 span_verfiyd_job Full-time_">Featured</span> -->
                              <!-- <span class="d-block mx-0 mt-2"
                                ><img src="images/new_home/Verified.svg" alt="view-all-industries-icon"/></span
                              > -->
                              <!-- <span class="span_verfiyd_job Contract_ m-0" v-if="item.urgent == 1">Urgent</span> -->
                              <!-- </div> -->
                            </div>
                          </div>
                        </div>
                        <hr class="new_home_hr2" />
                        <div
                          class="job_deatils_by d-flex justify-content-between"
                        >
                          <div class="">
                            <!-- <span class="span_verfiyd_job">Verified</span> -->
                            <span
                              class="span_verfiyd_job Urgent_hiring_tag_job"
                              v-if="item.urgent == 1"
                              >Urgent</span
                            >
                            <span
                              class="span_verfiyd_job Freelancing"
                              v-for="(_item, _index) in item.job_type"
                              :key="_index + 's'"
                              :style="_index > 1 ? 'display:none' : ''"
                            >
                              {{ _item }}
                            </span>
                          </div>
                          <a
                            class=""
                            :href="
                              '/jobs-careers/pakistan/' +
                                item.location_city
                                  .map((v) => v.toLowerCase())
                                  .join('-') +
                                '/' +
                                item.job_title
                                  .toLowerCase()
                                  .replace(/ /g, '-')
                                  .replace(/[^\w-]+/g, '') +
                                '/' +
                                item.id
                            "
                          >
                            <span class="span_verfiyd_job span_view_d_job"
                              >Details</span
                            >
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-lg-4-by_ch blue_col_new_home home_fix_ch2">
            <h3 class="blue_new_home">
              Join our employment <br class="by-nine-ch" />
              network
            </h3>
            <hr class="blue_new_home_h" />
            <div class="row mx-0 mb-7 p-0">
              <div class="col-2 p-0">
                <img
                  class="mt-2"
                  src="images/new_home/Good_icon.webp"
                  alt="Join our employment network icon"
                />
              </div>
              <div class="col-10 p-0">
                <p class="m-0 blue_child_heading_new_home">
                  Apply to jobs faster <br class="by-nine-ch" />even from mobile
                </p>
              </div>
            </div>
            <div class="row mx-0 mb-7 p-0">
              <div class="col-2 p-0">
                <img
                  class="mt-2"
                  src="images/new_home/Good_icon.webp"
                  alt="Join our employment network icon"
                />
              </div>
              <div class="col-10 p-0">
                <p class="m-0 blue_child_heading_new_home">
                  Post a resume to be found by
                  <br class="by-nine-ch" />registered employers
                </p>
              </div>
            </div>
            <div class="row mx-0 mb-7 p-0">
              <div class="col-2 p-0">
                <img
                  class="mt-2"
                  src="images/new_home/Good_icon.webp"
                  alt="Join our employment network icon"
                />
              </div>
              <div class="col-10 p-0">
                <p class="m-0 blue_child_heading_new_home">
                  Get response alert <br class="by-nine-ch" />
                  for free
                </p>
              </div>
            </div>
            <hr class="blue_new_home_h" />
            <div class="pt-8">
              <a class="join_now_new_home" href="/job-seeker-register"
                >Join Now</a
              >
              <a class="register_new_home" href="/recruiter-registeration"
                >Register as a recruiter</a
              >
            </div>
          </div>
        </div>
      </div>
      <!-- Featured Recruiters -->
      <div class="new_home_ Featured_Recruiters mb-20">
        <div class="container">
          <h3 class="leatext_job_heading_by_new_home text-center">
            Featured Recruiters
          </h3>
          <div v-if="loading == true">
            <div class="row">
              <SkeletonLoader_1 />
              <div
                v-for="sk in 6"
                :key="'sk-frec-' + sk"
                class="col-6 col-md-2 p-0"
              >
                <div
                  class="well new_home_col_jobs bg-white border-0"
                  style="min-height: 140px"
                >
                  &nbsp;
                </div>
              </div>
            </div>
            <div class="new_home_ text-center pt-5">
              <a class="by_view_all" href="/recruiter-directory"
                >View all recruiters &nbsp;&nbsp;<img
                  src="images/new_home/Arrow.webp"
                  alt="view-all-recruiters-icon"
              /></a>
            </div>
          </div>
          <div v-else>
            <div class="row">
              <!-- {{featureCompaniesData}} -->
              <div
                class="col-6 col-md-2 p-0"
                v-for="(item, index) in featureCompaniesData"
                :key="index"
              >
                <div
                  class="well new_home_col_jobs bg-white border-0"
                  v-if="index < 12"
                >
                  <div class="row p-0 m-0 col-12">
                    <div class="col-6 p-0 m-0">
                      <div class="media-left p-0 pr-2">
                        <router-link
                          :to="
                            '/employer/' +
                              item.company_name
                                .toLowerCase()
                                .replace(/ /g, '-') +
                              '/' +
                              item.id
                          "
                        >
                          <img
                            class="media-object img-circle fiucher_c_ne_home"
                            @error="onImageLoadFailure($event)"
                            :src="mediaUrl + item.profile_pic || ''"
                            style="object-fit: cover"
                            alt="..."
                          />
                          <img
                            class="verfiyed_compony___2"
                            src="images/new_home/Verified.svg"
                            alt="Verified Compony"
                          />
                        </router-link>
                      </div>
                    </div>
                    <div class="col-6 p-0 m-0 mt-3">
                      <span
                        class="d-block mx-0 by_top_rated_CO span_verfiyd_job"
                        >Top Rated</span
                      >
                      <span
                        class="d-block mx-0 by_top_rated_CO fucherBYCHNEWS span_verfiyd_job"
                        >Featured</span
                      >
                    </div>
                  </div>
                  <div class="media mt-1">
                    <div class="media-body media-right p-0">
                      <h5 class="media-heading text-primary pt-0 by___yes">
                        <!-- <router-link
                        :to="
                          '/employer/' +
                          item.company_name.toLowerCase().replace(/ /g, '-') +
                          '/' +
                          item.id
                        "
                        item.company_name.split(' ').length
                      > -->
                        <router-link
                          :to="
                            '/employer/' +
                              item.company_name
                                .toLowerCase()
                                .replace(/ /g, '-') +
                              '/' +
                              item.id
                          "
                          class="text-dark company-name"
                          v-if="item"
                        >
                          <span
                            v-if="item.company_name.split(' ').length <= 6"
                            >{{ item.company_name }}</span
                          >
                          <span v-if="item.company_name.split(' ').length > 6">
                            ...</span
                          >
                          <!-- {{ item && item.company_name }} -->
                        </router-link>
                        <!-- </router-link> -->
                      </h5>
                      <h5 class="media-heading text-primary">
                        <div class="small_new_home3">
                          <span
                            v-for="(item__, index__) in item.industries"
                            :key="index__"
                            class="small_new_home"
                            >{{ item__ }}
                            <span v-if="index__ > 0 && index__ > 0"
                              >,</span
                            ></span
                          >
                        </div>
                        <br />
                        <div class="row pt-1 p-0 m-0 col-12">
                          <small
                            class="small_new_home2 small_new_home23 col-6 p-0 text-muted"
                          >
                            Est: {{ item.established_in }}
                          </small>
                          <small
                            v-if="item.employees"
                            class="small_new_home2 small_new_home23 col-6 p-0 text-muted text-end"
                          >
                            Emp: {{ item.employees }}
                          </small>
                          <small
                            v-if="!item.employees"
                            class="small_new_home2 small_new_home23 col-6 p-0 text-muted text-end"
                          >
                            Emp: ---
                          </small>
                        </div>
                        <hr
                          class="col-md-12 p-0 my-1"
                          style="background: rgba(53, 162, 229, 0.25);"
                        />
                        <div class="row p-0 m-0">
                          <div class="col-6 p-0">
                            <a
                              :href="
                                '/employer/' +
                                  item.company_name
                                    .toLowerCase()
                                    .replace(/ /g, '-') +
                                  '/' +
                                  item.id
                              "
                              ><button
                                data-v-5bbe3882=""
                                class="new_home_by_chbluebg_C"
                              >
                                +Follow
                              </button></a
                            >
                          </div>
                          <div class="col-6 p-0 text-end">
                            <a
                              :href="
                                '/employer/' +
                                  item.company_name
                                    .toLowerCase()
                                    .replace(/ /g, '-') +
                                  '/' +
                                  item.id
                              "
                              ><button
                                data-v-5bbe3882=""
                                class="new_home_by_chbluebg_C chchch____"
                              >
                                Jobs
                              </button></a
                            >
                          </div>
                        </div>
                      </h5>
                    </div>
                  </div>
                </div>
              </div>
              <div class="new_home_ text-center pt-5">
                <a class="by_view_all" href="/recruiter-directory"
                  >View all recruiters &nbsp;&nbsp;<img
                    src="images/new_home/Arrow.webp"
                    alt="view-all-industries-icon"
                /></a>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- jobs by Companys -->
      <div class="container px-3 pb-20 home_fixes_new_ch">
        <div class="row_by-ch p-0 m-0">
          <div class="col-lg-8_by-ch col-12 row m-0 bg-light-new-home">
            <div
              class="col-md-12 d-flex justify-content-between home_fixes_new_ch"
            >
              <h3 class="leatext_job_heading_by_new_home home_fixes_new_ch">
                Jobs by companies
              </h3>
            </div>
            <div v-if="loading == true">
              <div class="col-md-12 new_home_ home_fixes_new_ch">
                <hr class="new_home_hr" />
                <div class="tab-content" id="pills-tabContent">
                  <div class="">
                    <SkeletonLoader_2 />
                    <div class="row">
                      <div class="col-6 col-lg-6 home_fixes_new_ch22">
                        <div
                          class="newst_secter_list newst_secter_list_new_home"
                        >
                          <!-- <router-link
                            v-if="index < 16"
                            :to="
                              '/employer/' +
                                item.company_name
                                  .toLowerCase()
                                  .replace(/ /g, '-') +
                                '/' +
                                item.id
                            "
                            class="
                            text-muted
                            d-flex
                            justify-content-between
                            new_home_a
                          "
                          >
                            <span>
                              {{ item.company_name }}
                            </span>
                            <span>
                              <img
                                src="images/new_home/Arrow.webp"
                                alt="view-all-industries-icon"
                              />
                            </span>
                          </router-link> -->
                          <!-- <router-link v-if="index === 20" :to="'/recruiter-directory'"
                          >View All
                          <i class="ml-1 fa fa-angle-right"></i>
                        </router-link> -->
                        </div>
                      </div>
                    </div>
                    <hr class="new_home_hr" />
                    <div>
                      <a class="by_view_all" href="/recruiter-directory"
                        >View All &nbsp;&nbsp;<img
                          src="images/new_home/Arrow.webp"
                          alt="view-all-industries-icon"
                      /></a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div v-else>
              <div class="col-md-12 new_home_ home_fixes_new_ch">
                <hr class="new_home_hr" />
                <div class="tab-content" id="pills-tabContent">
                  <div class="">
                    <div class="row">
                      <div
                        class="col-6 col-lg-6 home_fixes_new_ch22"
                        v-for="(item, index) in CompaniesList"
                        :key="index"
                        :style="index < 16 ? '' : 'display: none '"
                      >
                        <div
                          class="newst_secter_list newst_secter_list_new_home"
                        >
                          <router-link
                            v-if="index < 16"
                            :to="
                              '/employer/' +
                                item.company_name
                                  .toLowerCase()
                                  .replace(/ /g, '-') +
                                '/' +
                                item.id
                            "
                            class="
                            text-muted
                            d-flex
                            justify-content-between
                            new_home_a
                          "
                          >
                            <span>
                              {{ item.company_name }}
                            </span>
                            <span>
                              <img
                                src="images/new_home/Arrow.webp"
                                alt="view-all-industries-icon"
                              />
                            </span>
                          </router-link>
                          <!-- <router-link v-if="index === 20" :to="'/recruiter-directory'"
                          >View All
                          <i class="ml-1 fa fa-angle-right"></i>
                        </router-link> -->
                        </div>
                      </div>
                    </div>
                    <hr class="new_home_hr" />
                    <div>
                      <a class="by_view_all" href="/recruiter-directory"
                        >View All &nbsp;&nbsp;<img
                          src="images/new_home/Arrow.webp"
                          alt="view-all-industries-icon"
                      /></a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            class="
              col-lg-4-by_ch
              col-12
              row
              m-0
              bg-light-new-home_4
              new_home_
              pb-5
            "
          >
            <h3 class="h3_by_new_home_blue">
              Command the brilliance <br class="by-nine-ch" />in job interviews
            </h3>
            <p class="m-0 p_by_new_home_blue">
              Stop worrying! Be prepared &<br class="by-nine-ch" />
              confident. Get ready and<br class="by-nine-ch" />
              breeze through it!
            </p>
            <img
              class=""
              src="images/new_home/Job_interview.webp"
              alt="Recruitment Assistance image"
            />
            <hr class="new_home_hr" />
            <div>
              <a class="by_view_all" href="/command-the-interview-brilliance"
                >Book a session &nbsp;&nbsp;<img
                  src="images/new_home/Arrow.webp"
                  alt="view-all-industries-icon"
              /></a>
            </div>
          </div>
        </div>
      </div>
      <!-- plan -->
      <div class="Featured_Recruiters" style="position: relative">
        <div class="container p-0" style="margin: 0 auto">
          <div class="row">
            <div class=" col-lg-12 pk_bg_img3 text-center mb-10">
              <h2 class="">Get <span>Flexible. Affordable.</span>solutions</h2>
            </div>
            <div class="container p-0 ">
              <div class='col-lg-12 row p-0 m-0'>
                <div class="col-md-3 col-12 basic">
                  <div class="" id="ShowCase">
                    <div class="">
                      <div class="solid ">
                        <div class="text-center">
                          <h2 style="font-size:42px;">Basic</h2>
                        </div>
                      </div>
                      <div class="list_price pb-1 mt-4">Rs. 2,999
                        <h3> 1 month validity</h3>
                      </div>
                      <!-- <div  style="text-decoration-line: underline;"></div -->
                      <hr class="new_home_hr" />
                      <div class=" col-lg-12">

                        <h2 class="heading_all"> <span class="tikgood">&#10003;</span>03 featured jobs on homepage</h2>
                      </div>
                      <div class="col-lg-12">
                        <h2 class="heading_all"> <span class="tikgood">&#10003;</span>03 jobs email push notfications
                        </h2>

                      </div>
                      <div class="col-lg-12">
                        <h2 class="heading_all"> <span class="tikgood">&#10003;</span>25 best match profiles</h2>

                      </div>
                      <div class="col-lg-12">
                        <h2 class="heading_all"> <span class="tikgood">&#10003;</span>Screening & shortlists assistance
                        </h2>

                      </div>
                      <div class="col-lg-12">
                        <h2 class="heading_all"> <span class="tikgood">&#10003;</span>Applicant tracking</h2>

                      </div>
                      <div class="child_bottom">
                        <button class="basic-btn mt-5 LETSGO" style="width: 90%">
                          <a href="/contact-us?Basic" style="color:#333333 !important;">
                            CONTACT TO BUY
                          </a>
                        </button>
                        <h6>Note: Job posting credit will be expired automatically after 1 month of your subscription.
                        </h6>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-md-3 col-12 basic">
                  <div class="" id="ShowCase">
                    <div class="">
                      <div class="standard_i">
                        <div class="text-center">
                          <h2 style="font-size:42px;">Standard</h2>
                        </div>
                      </div>
                      <div class="list_price pb-1 mt-4">Rs. 6,999
                        <h3> 2 months validity</h3>
                      </div>
                      <!-- <div  style="text-decoration-line: underline;"></div -->
                      <hr class="new_home_hr" />
                      <div class=" col-lg-12">

                        <h2 class="heading_all"> <span class="tikgood">&#10003;</span>05 featured jobs</h2>
                      </div>
                      <div class="col-lg-12">
                        <h2 class="heading_all"> <span class="tikgood">&#10003;</span>05 jobs email push notfications
                        </h2>

                      </div>
                      <div class="col-lg-12">
                        <h2 class="heading_all"> <span class="tikgood">&#10003;</span>50 best match profiles</h2>

                      </div>
                      <div class="col-lg-12">
                        <h2 class="heading_all"> <span class="tikgood">&#10003;</span>Screening & shortlists assistance
                        </h2>

                      </div>
                      <div class="col-lg-12">
                        <h2 class="heading_all"> <span class="tikgood">&#10003;</span>Applicant tracking</h2>

                      </div>
                      <div class="child_bottom">
                        <button class="standard-btn mt-5 LETSGO" style="width: 90%">
                          <a href="/contact-us?Standard" class="text-white">
                            CONTACT TO BUY
                          </a>
                        </button>
                        <h6>Note: Job posting credit will be expired automatically after 2 month of your subscription.
                        </h6>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-md-3 col-12 basic">
                  <div class="" id="ShowCase">
                    <div class="">
                      <div class="premium_i">
                        <div class="text-center">
                          <h2 style="font-size:42px;">Premium</h2>
                        </div>
                      </div>
                      <div class="list_price pb-1 mt-4">Rs. 11,999
                        <h3> 3 months validity</h3>
                      </div>
                      <!-- <div  style="text-decoration-line: underline;"></div -->
                      <hr class="new_home_hr" />
                      <div class=" col-lg-12">

                        <h2 class="heading_all"> <span class="tikgood">&#10003;</span>07 featured jobs</h2>
                      </div>
                      <div class="col-lg-12">
                        <h2 class="heading_all"> <span class="tikgood">&#10003;</span>07 jobs email push notfications
                        </h2>

                      </div>
                      <div class="col-lg-12">
                        <h2 class="heading_all"> <span class="tikgood">&#10003;</span>10 best match profiles</h2>

                      </div>
                      <div class="col-lg-12">
                        <h2 class="heading_all"> <span class="tikgood">&#10003;</span>Screening & shortlists assistance
                        </h2>

                      </div>
                      <div class="col-lg-12">
                        <h2 class="heading_all"> <span class="tikgood">&#10003;</span>Applicant tracking</h2>

                      </div>
                      <div class="col-lg-12">
                        <h2 class="heading_all"> <span class="tikgood">&#10003;</span>Job highlighted on homepage for 15
                          days</h2>

                      </div>
                      <div class="col-lg-12">
                        <h2 class="heading_all"> <span class="tikgood">&#10003;</span>Advertisement of company's logo on
                          homepage</h2>

                      </div>
                      <div class="child_bottom">
                        <button class="mt-5 LETSGO primium-btn" style="width: 90%">
                          <a href="/contact-us?Premium" style="color:#106409 !important;">
                            CONTACT TO BUY
                          </a>

                        </button>
                        <h6>Note: Job posting credit will be expired automatically after 3 month of your subscription.
                        </h6>

                      </div>
                    </div>
                  </div>

                </div>
                <div class="col-md-3 col-12 basic">
                  <div class="" id="ShowCase">
                    <div class="daimond_i">
                      <div class="text-center">
                        <h2 style="font-size:42px;">Daimond</h2>
                      </div>
                    </div>
                    <div class="list_price pb-1 mt-4">Rs. 15,999
                      <h3> 12 months validity</h3>
                    </div>
                    <!-- <div  style="text-decoration-line: underline;"></div -->
                    <hr class="new_home_hr" />
                    <div class=" col-lg-12 ">

                      <h2 class="heading_all"> <span class="tikgood">&#10003;</span>50 featured jobs</h2>
                    </div>
                    <div class="col-lg-12 ">
                      <h2 class="heading_all"> <span class="tikgood">&#10003;</span>50 jobs email push notfications</h2>

                    </div>
                    <div class="col-lg-12">
                      <h2 class="heading_all"> <span class="tikgood">&#10003;</span>150 best match profiles</h2>

                    </div>
                    <div class="col-lg-12">
                      <h2 class="heading_all"> <span class="tikgood">&#10003;</span>Screening & shortlists assistance
                      </h2>

                    </div>
                    <div class="col-lg-12">
                      <h2 class="heading_all"> <span class="tikgood">&#10003;</span>Applicant tracking</h2>

                    </div>
                    <div class="col-lg-12 ">
                      <h2 class="heading_all"> <span class="tikgood">&#10003;</span>Contact your potential candidates
                        directly from the site</h2>

                    </div>
                    <div class="col-lg-12">
                      <h2 class="heading_all"> <span class="tikgood">&#10003;</span>Advertisement of company's logo on
                        homepage</h2>

                    </div>
                    <div class="child_bottom">
                      <button class="daimond-btn mt-5 LETSGO" style="width: 90%">
                        <a href="/contact-us?Daimond" style="color:#A82511 !important;">
                          CONTACT TO BUY
                        </a>
                      </button>
                      <h6>Note: Job posting credit will be expired automatically after 12 month of your subscription.
                      </h6>

                    </div>
                  </div>

                </div>
              </div>
            </div>

            <div class="row px-10  m-0 mobile_p_ch_plan_home">
              <div class="col-lg-12 pk_bg_img3 pt-12 dg_s mt-10">
                <h6> Need for a bigger organisation or want custom Packages?</h6>
                <h2>Definitive <span>(Customized)</span>
                  <hr class="new_home_hr" />
                </h2>

                <p class="" style="text-align: left;
              font-size: 24px;">
                  Charges and features will be determined as per customer demand.
                  This package will include 6 months, 8 months, and 10 months subscription.
                </p>
                <div class="my-8" style="text-align: left">
                  <button class="rec_btn_phone" style="width: 197px;height: 45px;">
                    <a href="/contact-us" class="text-white">
                      CONTACT SALES
                    </a>
                  </button><br><br>
                  <h4>Contact us and we will be happy to assist you.
                    Our office hours are 10 am to 6 pm Monday through Saturday, and we attempt to respond to all
                    requests
                    within 1 business day.</h4>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- hiring in pakistan -->
      <div class="" style="">
        <div class="bg-white pb-5">
          <div class="container bg-white my-7 pb-10">
            <div class="row">
              <div class="col-lg-12 pb-7 home_fixes_new_ch">
                <div class="text-center new_home_heading_logos pt-5">
                  Companies currently hiring talent
                </div>
              </div>
            </div>
            <div class="row_by_logos_new_home">
              <div class="col_md_2_ch">
                <img src="images/new_home/engro.webp" alt="" />
              </div>
              <div class="col_md_2_ch">
                <img src="images/new_home/Coke.webp" alt="" />
              </div>
              <div class="col_md_2_ch">
                <img src="images/new_home/UBL.webp" alt="" />
              </div>
              <div class="col_md_2_ch">
                <img src="images/new_home/Waves.webp" alt="" />
              </div>
              <div class="col_md_2_ch">
                <img src="images/new_home/Haier.webp" alt="" />
              </div>
              <div class="col_md_2_ch d-none by_header_bu_dowlance">
                <img src="images/new_home/Recruiters1.svg" alt="" />
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- hiring in pakistan -->
      <div
        class="p_by_ch_b d_none_by_new_fix_last_tow"
        style="background: #e1e8f4"
      >
        <div class="bg-white pb-5">
          <div class="container bg-white my-7 pb-10">
            <div class="row">
              <div class="col-lg-6 pb-7">
                <img
                  src="images/new_home/BetterCareer.webp"
                  style="width: 100%"
                  alt="Better Career image"
                />
              </div>
              <div class="col-lg-6 pb-7">
                <div class="new_home_heading_logos">
                  We will help to find you <br class="by-nine-ch" />
                  the Jobs that are right for you
                </div>
                <p class="new_home_by_chbluebg1">
                  A better career is out there.<br class="by-nine-ch" />
                  We'll help you find it to become<br class="by-nine-ch" />
                  everything you want to be.
                </p>
                <a href="/recruiter-registeration">
                  <button class="new_home_by_chbluebg">Start now</button></a
                >
              </div>
              <div class="col-lg-6 pb-7 pt-15">
                <div
                  class="
                    new_home_heading_logos
                    text-end
                    new_home_last_heading_ch
                  "
                >
                  Explore our <br class="by-nine-ch" />
                  recruiters directory
                </div>
                <a href="/recruiter-directory">
                  <button
                    class="new_home_by_chbluebg mt-10"
                    style="float: right"
                  >
                    Explore now
                  </button></a
                >
              </div>
              <div class="col-lg-6 pb-7 pt-15">
                <img
                  src="images/new_home/Recruiters.webp"
                  style="width: 90%"
                  alt="Recruiters image"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- Browse by cities -->
      <div class="new_home_ mb-20 Featured_Recruiters _2nd mb-0">
        <div class="container row_by-ch2 pr-3">
          <div class="col-lg-8_by-ch pl-0">
            <div class="">
              <div class="col-lg-12 p-0">
                <div class="px-4 home_fixes_new_ch22">
                  <div class="row my-0">
                    <div class="col-lg-9 col-12 pb-0 pl-0 pr-0 mb-0">
                      <h3 class="leatext_job_heading_by_new_home pb-0 mb-8">
                        Browse by cities:
                      </h3>
                    </div>
                    <div
                      class="col-lg-3 col-12 p-0 chchchch"
                      style="text-align: end"
                    >
                      <div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-sm-12 pr-0 home_fixes_new_ch22">
                <div class="row mr-0 p-0">
                  <div class="col-md-6 row_by_new_city m-0 p-0">
                    <div class="col_by_city border_new_home">
                      <a
                        class="text-center city_jobs_new_home"
                        href="/jobs/Pakistan/Islamabad"
                      >
                        Islamabad
                        <img
                          class="w_100_img_new_city dufalt"
                          src="images/new_home/Islamabad.svg"
                          alt="Islamabad image"
                        />
                        <img
                          class="w_100_img_new_city hover_img d-none"
                          src="images/new_home/Islamabad@3x.webp"
                          alt="Islamabad image"
                        />
                      </a>
                    </div>
                    <div class="col_by_city border_new_home">
                      <a
                        class="text-center city_jobs_new_home"
                        href="/jobs/Pakistan/Karachi"
                      >
                        Karachi
                        <img
                          class="w_100_img_new_city dufalt Karachi"
                          src="images/new_home/Karachi.svg"
                          alt="Karachi image"
                        />
                        <img
                          class="w_100_img_new_city hover_img d-none"
                          src="images/new_home/Karachi_hover.webp"
                          style="width: 53% !important"
                          alt="Karachi image"
                        />
                      </a>
                    </div>
                    <div class="col_by_city border_new_home">
                      <a
                        class="text-center city_jobs_new_home"
                        href="/jobs/Pakistan/Quetta"
                      >
                        Quetta
                        <img
                          class="w_100_img_new_city img2 dufalt"
                          src="images/new_home/Quetta.svg"
                          alt="Quetta image"
                        />
                        <img
                          class="w_100_img_new_city img2 hover_img d-none"
                          src="images/new_home/Quetta_hover.webp"
                          alt="Quetta image"
                        />
                      </a>
                    </div>
                    <div class="col_by_city border_new_home">
                      <a
                        class="text-center city_jobs_new_home"
                        href="/jobs/Pakistan/Peshawar"
                      >
                        Peshawar
                        <img
                          class="w_100_img_new_city img2 dufalt"
                          src="images/new_home/Peshawar.svg"
                          alt="Peshawar image"
                        />
                        <img
                          class="w_100_img_new_city img2 hover_img d-none"
                          src="images/new_home/Peshawar_hover.webp"
                          alt="Peshawar image"
                        />
                      </a>
                    </div>
                  </div>
                  <div
                    class="
                      col-md-6
                      row_by_new_city2
                      m-0
                      pr-0
                      pl-3
                      home_fixes_new_ch22
                    "
                  >
                    <div class="col_by_city border_new_home">
                      <a
                        class="text-center city_jobs_new_home"
                        href="/jobs/Pakistan/Lahore"
                      >
                        Lahore
                        <img
                          class="w_100_img_new_city dufalt lahore_image"
                          src="images/new_home/Lahore.svg"
                          alt="Lahore image"
                        />
                        <img
                          class="w_100_img_new_city hover_img d-none"
                          style="width: 108% !important"
                          src="images/new_home/Lahore_hover.webp"
                          alt="Lahore image"
                        />
                      </a>
                    </div>
                    <div class="col_by_city border_new_home">
                      <a
                        class="text-center city_jobs_new_home"
                        href="/jobs/Pakistan/Sialkot"
                      >
                        Sialkot
                        <img
                          class="w_100_img_new_city dufalt"
                          src="images/new_home/Sialkot.svg"
                          alt="Sialkot image"
                        />
                        <img
                          class="w_100_img_new_city hover_img d-none"
                          style="width: 74% !important"
                          src="images/new_home/Sialkot_hover.webp"
                          alt="Sialkot image"
                        />
                      </a>
                    </div>
                    <div class="col_by_city border_new_home">
                      <a
                        class="text-center city_jobs_new_home"
                        href="/jobs/Pakistan/Faisalabad"
                      >
                        Faisalabad
                        <img
                          class="w_100_img_new_city dufalt"
                          src="images/new_home/Faisalabad.svg"
                          alt="Faisalabad image"
                        />
                        <img
                          class="w_100_img_new_city hover_img d-none"
                          style="width: 86% !important"
                          src="images/new_home/Faisalabad_hover.webp"
                          alt="Faisalabad image"
                        />
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-lg-4-by_ch blue_col_new_home bg_blue_ch_dark">
            <h3 class="text-white text-center font-weight-bold">
              Create a quick account or login
            </h3>
            <p class="text-white text-center m-0">
              Enter into world of opportunities
            </p>
            <div class="col-sm-12 mt-6 p-0 login_new_home_prent">
              <div class="row login_tab_hearder login_new_home">
                <div class="col-lg-12 dollg5 px-4 mb-0 home_fixes_new_ch">
                  <ul
                    class="nav nav-pills login_tabs"
                    id="pills-tab"
                    role="tablist"
                    style="background: transparent"
                  >
                    <li class="nav-item" role="presentation">
                      <button
                        class="nav-link active newest_btn"
                        id="pill-sign-tab"
                        data-bs-toggle="pill"
                        data-bs-target="#pill-sign"
                        type="button"
                        role="tab"
                        aria-controls="pill-sign"
                        aria-selected="true"
                      >
                        SIGN UP
                      </button>
                    </li>
                    <li class="nav-item" role="presentation">
                      <button
                        class="nav-link newest_btn"
                        id="pills-login-tab"
                        data-bs-toggle="pill"
                        data-bs-target="#pills-login"
                        type="button"
                        role="tab"
                        aria-controls="pills-login"
                        aria-selected="false"
                      >
                        LOGIN
                      </button>
                    </li>
                  </ul>
                </div>
              </div>
              <div class="row">
                <div class="col-lg-12 pl-4 pb-0 pt-0 pr-5 home_fixes_new_ch">
                  <div class="tab-content" id="pills-tabContent">
                    <div
                      class="tab-pane fade show active"
                      id="pill-sign"
                      role="tabpanel"
                      aria-labelledby="pill-sign-tab"
                    >
                      <div class="row">
                        <!-- ////////////////////////////////////////////////// -->
                        <div class="login-form login-signup home_fixes_new_ch">
                          <form
                            class="form"
                            novalidate="novalidate"
                            id="kt_login_signup_form"
                            @submit.stop.prevent="onSubmitRegister()"
                          >
                            <div class="form-check form-check-inline ml-2">
                              <input
                                class="form-check-input"
                                type="radio"
                                name="direct_recruitment"
                                id="direct_employer"
                                @change="recruiterSignUp_fun()"
                              />
                              <label
                                class="form-check-label text-white"
                                for="direct_employer"
                              >
                                Job seeker
                              </label>
                            </div>
                            <div class="form-check form-check-inline mb-5">
                              <input
                                class="form-check-input"
                                type="radio"
                                name="direct_recruitment"
                                id="recruitment_agency"
                                @change="agencySignUp_fun()"
                              />
                              <label
                                class="form-check-label text-white"
                                for="recruitment_agency"
                              >
                                Direct employer
                              </label>
                            </div>
                            <!-- ............. -->
                            <div class="form-group mb-3">
                              <input
                                class="form-control fieldch text-white"
                                type="text"
                                placeholder="Full Name"
                                name="firstName"
                                ref="firstName"
                                autocomplete="off"
                              />
                            </div>
                            <div
                              class="form-group mb-3"
                              v-if="agencySignUp == true"
                            >
                              <input
                                class="form-control fieldch text-white"
                                type="text"
                                placeholder="Compnay name"
                                name="compnay_name_ref"
                                ref="compnay_name_ref"
                                autocomplete="off"
                              />
                            </div>
                            <div class="form-group mb-3">
                              <input
                                class="form-control fieldch text-white"
                                type="email"
                                placeholder="Email Address"
                                name="email"
                                ref="remail"
                                autocomplete="off"
                              />
                            </div>
                            <div class="form-group mb-3">
                              <input
                                class="form-control fieldch text-white"
                                type="password"
                                placeholder="Enter Password"
                                name="password"
                                ref="rpassword"
                                autocomplete="off"
                              />
                            </div>
                            <div class="form-group mb-3">
                              <input
                                class="form-control fieldch text-white"
                                type="password"
                                placeholder="Retype Password"
                                name="cpassword"
                                ref="cpassword"
                                autocomplete="off"
                              />
                            </div>
                            <div
                              class="
                                form-group
                                d-flex
                                flex-wrap
                                pb-lg-0 pb-1
                                mt-7
                                mb-0
                              "
                            >
                              <button
                                ref="kt_login_signup_submit"
                                class="
                                  btn btn-default btn-lg
                                  home_auth_btn
                                  new_home_by_ch
                                "
                              >
                                Sign Up
                              </button>
                            </div>
                          </form>
                        </div>
                        <!-- /////////////////////////////////////////////////// -->
                      </div>
                    </div>
                    <div
                      class="tab-pane fade"
                      id="pills-login"
                      role="tabpanel"
                      aria-labelledby="pills-login-tab"
                    >
                      <div class="row">
                        <!-- ///////////////////////////////login -->
                        <div class="login-form login-signin home_fixes_new_ch">
                          <form
                            class="form"
                            novalidate="novalidate"
                            id="kt_login_signin_form"
                            @submit.stop.prevent="onSubmitLogin()"
                          >
                            <div
                              class="pb-5 pt-lg-0 pt-5 pl-2 text-white"
                              style="display: flex;flex-direction: column;font-size: 15px;opacity: 0.8;"
                            >
                              Login as a Job Sekeer or Employer
                            </div>
                            <div class="form-group">
                              <div
                                id="example-input-group-1"
                                label=""
                                label-for="example-input-1"
                              >
                                <input
                                  class="form-control fieldch text-white"
                                  type="text"
                                  name="email"
                                  placeholder="Enter Email Adderss"
                                  ref="email"
                                  v-model="form.email"
                                />
                              </div>
                            </div>
                            <div class="form-group">
                              <div class="d-flex justify-content-between mt-n5">
                                <label
                                  class="
                                    font-size-h6 font-weight-bolder
                                    text-dark
                                    pt-5
                                  "
                                ></label>
                                <a
                                  class="
                                    font-size-h6 font-weight-bolder
                                    text-hover-primary
                                    pt-5
                                    f-left
                                  "
                                  id="kt_login_forgot"
                                  href="/forgot"
                                  >Forgot Password ?</a
                                >
                              </div>
                              <div
                                id="example-input-group-2"
                                label=""
                                label-for="example-input-2"
                              >
                                <input
                                  class="form-control fieldch text-white"
                                  type="password"
                                  name="password"
                                  placeholder="Enter Password"
                                  ref="password"
                                  v-model="form.password"
                                  autocomplete="off"
                                />
                              </div>
                            </div>
                            <div class="pb-lg-0 pb-5">
                              <button
                                ref="kt_login_signin_submit"
                                class="
                                  btn btn-default btn-lg
                                  home_auth_btn
                                  new_home_by_ch
                                "
                              >
                                Login
                              </button>
                            </div>
                          </form>
                        </div>
                        <!-- //////////////////////////////login -->
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <!--end section-->
    <!-- Hero End -->

    <Footer />
    <!-- Footer End -->
    <Switcher />
    <!-- Back to top -->
    <a
      href="javascript: void(0);"
      class="btn btn-icon btn-soft-primary back-to-top"
      id="back-to-top"
      v-scroll-to="'#topnav'"
    >
      <arrow-up-icon class="icons"></arrow-up-icon>
    </a>
    <!-- Back to top -->
  </div>
</template>

<style scoped>
body {
  font-size: 15px !important;
}
.text-muted {
  color: black !important;
}
.settings {
  display: none !important;
}
._bold {
  font-weight: bold;
}
.pix12 {
  font-size: 12px;
}
.vjs_video_3-dimensions {
  width: 602px !important;
  height: 376px !important;
}

.video-js[tabindex="-1"] {
  outline: none;
  /* width: 177%; */
}

@media (min-width: 1024px) {
  .job-profile {
    top: 0px !important;
  }
}

.job_city_title:link {
  text-decoration: none !important;
}
.job_city_title:visited {
  text-decoration: none !important;
}
.job_city_title:hover {
  text-decoration: none !important;
}
.job_city_title:hover {
  color: white !important;
}
.job_city_title:active {
  text-decoration: none !important;
}
.bold {
  font-weight: bold !important;
}
.filter_heading {
  font-weight: bold;
  font-size: 13px;
  padding-left: 5%;
  padding-top: 5%;
  padding-bottom: 5%;
}
.detail_heading {
  font-weight: bold !important;
  font-size: 13px !important;
}
.detail_body {
  font-size: 13px !important;
}
.multiselect__placeholder {
  font-size: 13px !important;
}
.multiselect__option {
  font-size: 13px !important;
}
.multiselect__tag {
  font-size: 10px !important;
}
.job-box:hover {
  -webkit-transform: none !important;
  transform: none !important;
}
fieldset[disabled] .multiselect {
  pointer-events: none;
}
.multiselect__spinner {
  position: absolute;
  right: 1px;
  top: 1px;
  width: 48px;
  height: 35px;
  background: #fff;
  display: block;
}
.multiselect__spinner:after,
.multiselect__spinner:before {
  position: absolute;
  content: "";
  top: 50%;
  left: 50%;
  margin: -8px 0 0 -8px;
  width: 16px;
  height: 16px;
  border-radius: 100%;
  border-color: #41b883 transparent transparent;
  border-style: solid;
  border-width: 2px;
  box-shadow: 0 0 0 1px transparent;
}
.multiselect__spinner:before {
  animation: a 2.4s cubic-bezier(0.41, 0.26, 0.2, 0.62);
  animation-iteration-count: infinite;
}
.multiselect__spinner:after {
  animation: a 2.4s cubic-bezier(0.51, 0.09, 0.21, 0.8);
  animation-iteration-count: infinite;
}
.multiselect__loading-enter-active,
.multiselect__loading-leave-active {
  transition: opacity 0.4s ease-in-out;
  opacity: 1;
}
.multiselect__loading-enter,
.multiselect__loading-leave-active {
  opacity: 0;
}
.multiselect,
.multiselect__input,
.multiselect__single {
  font-family: inherit;
  font-size: 14px;
  -ms-touch-action: manipulation;
  touch-action: manipulation;
}
.multiselect {
  box-sizing: content-box;
  display: block;
  position: relative;
  width: 100%;
  min-height: 40px;
  text-align: left;
  color: #35495e;
}
.multiselect * {
  box-sizing: border-box;
}
.multiselect:focus {
  outline: none;
}
.multiselect--disabled {
  pointer-events: none;
  opacity: 0.6;
}
.multiselect--active {
  z-index: 1;
}
.multiselect--active .multiselect__current,
.multiselect--active .multiselect__input,
.multiselect--active .multiselect__tags {
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
}
.multiselect--active .multiselect__select {
  transform: rotate(180deg);
}
.multiselect--above.multiselect--active .multiselect__current,
.multiselect--above.multiselect--active .multiselect__input,
.multiselect--above.multiselect--active .multiselect__tags {
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}
.multiselect__input,
.multiselect__single {
  position: relative;
  display: inline-block;
  min-height: 20px;
  line-height: 20px;
  border: none;
  border-radius: 5px;
  background: #fff;
  padding: 1px 0 0 5px;
  width: 100%;
  transition: border 0.1s ease;
  box-sizing: border-box;
  margin-bottom: 8px;
}
.multiselect__tag ~ .multiselect__input,
.multiselect__tag ~ .multiselect__single {
  width: auto;
}
.multiselect__input:hover,
.multiselect__single:hover {
  border-color: #cfcfcf;
}
.multiselect__input:focus,
.multiselect__single:focus {
  border-color: #a8a8a8;
  outline: none;
}
.multiselect__single {
  padding-left: 6px;
  margin-bottom: 8px;
}
.multiselect__tags {
  min-height: 38px !important;
  padding: 10px 40px 0 8px !important;
}
.multiselect__tag {
  position: relative;
  display: inline-block;
  padding: 4px 26px 4px 10px;
  border-radius: 5px;
  margin-right: 10px;
  color: #fff;
  line-height: 1;
  background: #41b883;
  margin-bottom: 8px;
  white-space: nowrap;
}
.multiselect__tag-icon {
  cursor: pointer;
  margin-left: 7px;
  position: absolute;
  right: 0;
  top: 0;
  bottom: 0;
  font-weight: 700;
  font-style: normal;
  width: 22px;
  text-align: center;
  line-height: 22px;
  transition: all 0.2s ease;
  border-radius: 5px;
}
.multiselect__tag-icon:after {
  content: "\D7";
  color: #266d4d;
  font-size: 14px;
}
.multiselect__tag-icon:focus,
.multiselect__tag-icon:hover {
  background: #369a6e;
}
.multiselect__tag-icon:focus:after,
.multiselect__tag-icon:hover:after {
  color: #fff;
}
.multiselect__current {
  min-height: 40px;
  overflow: hidden;
  padding: 8px 12px 0;
  padding-right: 30px;
  white-space: nowrap;
  border-radius: 5px;
  border: 1px solid #e8e8e8;
}
.multiselect__current,
.multiselect__select {
  line-height: 16px;
  box-sizing: border-box;
  display: block;
  margin: 0;
  text-decoration: none;
  cursor: pointer;
}
.multiselect__select {
  position: absolute;
  width: 40px;
  height: 38px;
  right: 1px;
  top: 1px;
  padding: 4px 8px;
  text-align: center;
  transition: transform 0.2s ease;
}
.multiselect__select:before {
  position: relative;
  right: 0;
  top: 65%;
  color: #999;
  margin-top: 4px;
  border-style: solid;
  border-width: 5px 5px 0;
  border-color: #999 transparent transparent;
  content: "";
}
.multiselect__placeholder {
  color: #adadad;
  display: inline-block;
  margin-bottom: 10px;
  padding-top: 2px;
}
.multiselect--active .multiselect__placeholder {
  display: none;
}
.multiselect__content {
  position: absolute;
  list-style: none;
  display: block;
  background: #fff;
  width: 100%;
  max-height: 240px;
  overflow: auto;
  padding: 0;
  margin: 0;
  border: 1px solid #e8e8e8;
  border-top: none;
  border-bottom-left-radius: 5px;
  border-bottom-right-radius: 5px;
  z-index: 1;
}
.multiselect--above .multiselect__content {
  bottom: 100%;
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
  border-top-left-radius: 5px;
  border-top-right-radius: 5px;
  border-bottom: none;
  border-top: 1px solid #e8e8e8;
}
.multiselect__content::webkit-scrollbar {
  display: none;
}
.multiselect__element {
  display: block;
}
.multiselect__option {
  display: block;
  padding: 12px;
  min-height: 40px;
  line-height: 16px;
  text-decoration: none;
  text-transform: none;
  vertical-align: middle;
  position: relative;
  cursor: pointer;
  white-space: nowrap;
}
.multiselect__option:after {
  top: 0;
  right: 0;
  position: absolute;
  line-height: 40px;
  padding-right: 12px;
  padding-left: 20px;
}
.multiselect__option--highlight {
  background: #41b883;
  outline: none;
  color: #fff;
}
.multiselect__option--highlight:after {
  content: attr(data-select);
  background: #41b883;
  color: #fff;
}
.multiselect__option--selected {
  background: #f3f3f3;
  color: #35495e;
  font-weight: 700;
}
.multiselect__option--selected:after {
  content: attr(data-selected);
  color: silver;
}
.multiselect__option--selected.multiselect__option--highlight {
  background: #ff6a6a;
  color: #fff;
}
.multiselect__option--selected.multiselect__option--highlight:after {
  background: #ff6a6a;
  content: attr(data-deselect);
  color: #fff;
}
.multiselect--disabled {
  background: #ededed;
  pointer-events: none;
}
.multiselect--disabled .multiselect__current,
.multiselect--disabled .multiselect__select,
.multiselect__option--disabled {
  background: #ededed;
  color: #a6a6a6;
}
.multiselect__option--disabled {
  cursor: text;
  pointer-events: none;
}
.verfiyed_compony___2 {
  position: absolute;
  left: 54px !important;
  top: -3px !important;
}
.multiselect__option--disabled.multiselect__option--highlight {
  background: #dedede !important;
}
.multiselect-enter-active,
.multiselect-leave-active {
  transition: all 0.15s ease;
}
.multiselect-enter,
.multiselect-leave-active {
  opacity: 0;
}
@keyframes a {
  0% {
    transform: rotate(0);
  }
  to {
    transform: rotate(2turn);
  }
}
</style>
